import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import Task305Game from './game';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task305: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    useEffect(() => {
        if (completeCallback) {
            completeCallback()
        }
    }, [completeCallback])

    const { task } = useTask('t-305');

    return <div className="task task-305">
        <h2>zadanie 5</h2>
        <h3>{task?.title}</h3>
        <p>
            Hania Humorek przygotowuje się do turnieju książkowego. Jej brat Smrodek, z którym jest w drużynie, przygotował dla niej kilka zagadek na rozgrzewkę.
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Pomóżcie Hani rozwiązać zagadki. Odpowiedzi wpisujcie w miejsce poniżej. Każda odpowiedź składa się z tylko jednego wyrazu!
        </p>
        <Task305Game onComplete={onComplete} />
    </div>
}

export default Task305;
